module.exports = __webpack_public_path__ + "static/awards-icon-10-7488c32051655eb799368aae91fbb7d6.png";